import { useMutation } from "react-query";
import { checkPromotionCodeV2 } from "src/service/pay";
import { useApiError } from "src/hooks/useApiError";
import {
  ICheckPromotionCodeReq,
  ICheckPromotionCodeRes,
} from "src/service/types/pay.type";

interface IUseCheckPromotionProps {
  onSuccess?: (data: ICheckPromotionCodeRes) => void;
  onError?: (error: any) => void;
}

export function useCheckPromotion({
  onSuccess,
  onError,
}: IUseCheckPromotionProps = {}) {
  const { handleError } = useApiError();

  const {
    isLoading,
    mutateAsync: checkPromotionMutation,
    data,
    error,
    isError,
    isSuccess,
  } = useMutation<ICheckPromotionCodeRes, any, ICheckPromotionCodeReq>(
    "checkPromotionCodeV2",
    checkPromotionCodeV2,
    {
      onSuccess: onSuccess || (() => {}),
      onError: onError || handleError,
    }
  );

  return {
    isLoading,
    checkPromotionMutation,
    data,
    error,
    isError,
    isSuccess,
  };
}
